import axios from 'axios';

export default class ApiImportador {
    file(url, dados) {
		return axios.post(
			this.getHostImportador() + url,
			dados, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
		).then(
			((response) => {
				return response.data
			})
		);
	}

    getHostImportador() {
        return process.env.VUE_APP_API_IMPORTADOR;
    }
}